import { toAbsoluteUrl } from "../../../services";

let ChartOverviewData = [
  {
    name: "Total Registration",
    checked: true,
    key: "Total Registration",
  },
  {
    name: "In Progress",
    checked: false,
    key: "In Progress",
  },
  {
    name: "Completed",
    checked: false,
    key: "Completed",
  },
  {
    name: "Locked Users",
    checked: false,
    key: "Locked Users",
  },
  {
    name: "Only Registered",
    checked: false,
    key: "Only Registered",
  },
];

let CompetencyData = [
  {
    name: "External Orientation",
    iconUrl: toAbsoluteUrl("/media/nrp/dashboard/External_Orientation.png"),
    value: 80,
  },
  {
    name: "Imagination",
    iconUrl: toAbsoluteUrl("/media/nrp/dashboard/Imaginition.png"),
    value: 80,
  },
  {
    name: "Innovation",
    iconUrl: toAbsoluteUrl("/media/nrp/dashboard/Innovation.png"),
    value: 80,
  },
  {
    name: "Strategic Thinking",
    iconUrl: toAbsoluteUrl("/media/nrp/dashboard/Strategic_Thinking.png"),
    value: 80,
  },
  {
    name: "Customer Focused",
    iconUrl: toAbsoluteUrl("/media/nrp/dashboard/Costumer_Focused.png"),
    value: 80,
  },
];

let CognitiveData = [
  {
    name: "Working Memory",
    iconUrl: toAbsoluteUrl("/media/nrp/dashboard/Planning.png"),
    value: 80,
  },
  {
    name: "Planning",
    iconUrl: toAbsoluteUrl("/media/nrp/dashboard/Planning.png"),
    value: 80,
  },
  {
    name: "Divided Attention",
    iconUrl: toAbsoluteUrl("/media/nrp/dashboard/Divided_Attention.png"),
    value: 80,
  },
  {
    name: "Cognitive Flexibility",
    iconUrl: toAbsoluteUrl("/media/nrp/dashboard/Flexibility.png"),
    value: 80,
  },
  {
    name: "Updating",
    iconUrl: toAbsoluteUrl("/media/nrp/dashboard/Updating.png"),
    value: 80,
  },
];

let ChartsTabsData = [
  {
    name: "University",
    key: "byUniversity",
  },
  {
    name: "Specialisation",
    key: "bySpecialisation",
  },
  {
    name: "Qualification",
    key: "byQualification",
  },
];

let ChartsTabsData1 = [
  {
    name: "Area Of Interest",
    key: "byAreaOfInterest",
  },
  {
    name: "Nationality",
    key: "byNationality",
  },
  {
    name: "Gender",
    key: "byGender",
  },
];

let competenciesAssessments = {
  "Hand Em Right": {
    title: "Working Memory",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/working_memory.png"),
  },
  "Flip Flop": {
    title: "Cognitive Flexibility",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/cognitive_flexibility.png"),
  },
  "Box Sort": {
    title: "Divided Attention",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/divided_attention.png"),
  },
  Binder: {
    title: "Focused Attention",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/focused_attention.png"),
  },
  "Money Sort": {
    title: "Sustained Attention",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/sustained_attention.png"),
  },
  "Money Count": {
    title: "Updating",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/updating.png"),
  },
  "Make Way": {
    title: "Planning",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/planning.png"),
  },
  "Color Match": {
    title: "Inhibitory Response",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/inhibitory_control.png"),
  },
  "Number Rush": {
    title: "Basic Arithmetic",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/number_rush.png"),
  },
  "Light's Out": {
    title: "English Verbal Reasoning",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/Lights_out.png"),
  },
  "Park It": {
    title: "Numerical Logic",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/parkit.png"),
  },
  "Amnesia": {
    title: "Inductive Reasoning",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/Amnesia.png"),
  },
  "Hand Em Right ": {
    title: "Working Memory",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/working_memory.png"),
  },
  "Flip Flop ": {
    title: "Cognitive Flexibility",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/cognitive_Flexibility.png"),
  },
  "Box Sort ": {
    title: "Divided Attention",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/divided_attention.png"),
  },
  "Binder ": {
    title: "Focused Attention",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/focused_attention.png"),
  },
  "Money Sort ": {
    title: "Sustained Attention",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/sustained_attention.png"),
  },
  "Money Count ": {
    title: "Updating",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/updating.png"),
  },
  "Make Way ": {
    title: "Planning",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/planning.png"),
  },
  "Color Match ": {
    title: "Inhibitory Response",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/inhibitory_control.png"),
  },
  "Number Rush ": {
    title: "Basic Arithmetic",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/.png"),
  },
  "Light's Out ": {
    title: "English Verbal Reasoning",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/.png"),
  },
  "Park It ": {
    title: "Numerical Logic",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/.png"),
  },
  "Amnesia ": {
    title: "Inductive Reasoning",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/.png"),
  },
  "That's My Problem": {
    title: "Agility",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/agility.png"),
  },
  "When Have I Ever?": {
    title: "Character",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/character.png"),
  },
  Boomerang: {
    title: "Collaboration",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/collaboration.png"),
  },
  "Damaged Goods": {
    title: "Customer Focused",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/customer_focused.png"),
  },
  "Sum Of Its Parts": {
    title: "Delegation",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/delegation.png"),
  },
  "Let's Grow": {
    title: "Develop Others",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/develop_others.png"),
  },
  "And, Action!": {
    title: "Drive For Results",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/drive_for_results.png"),
  },
  "Picture Perfect": {
    title: "Effective Communication",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/effective_communication.png"),
  },
  Daredevil: {
    title: "Entrepreneurship",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/entrepreneurship.png"),
  },
  "The Full Circle": {
    title: "External Orientation",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/external_ orientation.png"),
  },
  Slingshot: {
    title: "Imagination",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/imaginition.png"),
  },
  Savvy: {
    title: "Influence",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/influence.png"),
  },
  "New Horizon": {
    title: "Innovation",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/innovation.png"),
  },
  "Now What": {
    title: "Investing In Self",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/investing_in_self.png"),
  },
  Bedrock: {
    title: "Perseverance",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/perseverence.png"),
  },
  "Fix'Em Up": {
    title: "Planning",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/planning.png"),
  },
  "Oh My!": {
    title: "Recognition",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/recognition.png"),
  },
  "It Happens": {
    title: "Set Direction",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/set_direction.png"),
  },
  "The Big Move": {
    title: "Strategic Thinking",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/strategic_thinking.png"),
  },
  "Anyone? Everyone!": {
    title: "Valuing Diversity",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/valuing_diversity.png"),
  },
  "What's Next": {
    title: "English Verbal Reasoning",
    imgSrc: toAbsoluteUrl("/media/nrp/dashboard/Lights_out.png"),
  },
};

let filterColumns = {

  "name": "Name",
  "email": "Email",
  "gender": "Gender",
  "dob": "Date Of Birth",
  "phone": "Phone",
  "city": "City",
  "country": "Country",
  "address": "Address",
  "nationality": "Nationality",
  "currentCountry": "Country of Residence",
  "cnic": "Identity Card",
  "cnicIssuanceDate": "Identity Card Issuance Date",
  "healthDisability": "Health Disability",
  "countryOther": "Country of Highest Education",
  "university": "University",
  "qualification": "Qualification",
  "specialization": "Specialization",
  "graduationDate": "Graduation Date",
  "degreeDuration": "Degree Duration",
  "gradingSystem": "Grading System",
  "gradingValue": "Grade",
  "areaOfInterest1": "Primary Area Of Interest",
  "areaOfInterest2": "Secondary Area Of Interest",
  "preferredCity": "Preferred City to Work in",
  "resume": "Resume",
  "totalScore": "Total Score",
  "totalCompetencyScore": "Total Competency Score",
  "totalConativeScore": "Total Conative Score",
  "percentileRank": "Percentile Rank",
  "createdAt": "Date Game Started",
  "updatedAt": "Last Date Updated",
  "gamePlayPercentage": "Game Play Percentage",
  "userLockStatus": "Lock Status",
  "userLockType": "Lock Type",

  "Hand Em Right": "Working Memory",
  "Flip Flop": "Cognitive Flexibility",
  "Box Sort": "Divided Attention",
  Binder: "Focused Attention",
  "Money Sort": "Sustained Attention",
  "Money Count": "Updating",
  "Make Way": "Planning",
  "Color Match": "Inhibitory Response",
  "Number Rush": "Basic Arithmetic",
  "Light's Out": "English Verbal Reasoning",
  "Park It": "Numerical Logic",
  Amnesia: "Inductive Reasoning",
  "Hand Em Right ": "Working Memory",
  "Flip Flop ": "Cognitive Flexibility",
  "Box Sort ": "Divided Attention",
  "Binder ": "Focused Attention",
  "Money Sort ": "Sustained Attention",
  "Money Count ": "Updating",
  "Make Way ": "Planning",
  "Color Match ": "Inhibitory Response",
  "Number Rush ": "Basic Arithmetic",
  "Light's Out ": "English Verbal Reasoning",
  "Park It ": "Numerical Logic",
  "Amnesia ": "Inductive Reasoning",
  "That's My Problem": "Agility",
  "When Have I Ever?": "Character",
  Boomerang: "Collaboration",
  "Damaged Goods": "Customer Focused",
  "Sum Of Its Parts": "Delegation",
  "Let's Grow": "Develop Others",
  "And, Action!": "Drive For Results",
  "Picture Perfect": "Effective Communication",
  Daredevil: "Entrepreneurship",
  "The Full Circle": "External Orientation",
  Slingshot: "Imagination",
  Savvy: "Influence",
  "New Horizon": "Innovation",
  "Now What": "Investing In Self",
  Bedrock: "Perseverance",
  "Fix'Em Up": "Planning",
  "Oh My!": "Recognition",
  "It Happens": "Set Direction",
  "The Big Move": "Strategic Thinking",
  "Anyone? Everyone!": "Valuing Diversity",
  "What's Next": "English Verbal Reasoning",
};

export {
  ChartOverviewData,
  CompetencyData,
  CognitiveData,
  ChartsTabsData,
  ChartsTabsData1,
  competenciesAssessments,
  filterColumns
};
